module.exports = __webpack_public_path__ + "img/location.e76ef630.svg";